// Field — tiny labeled form-field wrapper, extracted from src/App.jsx (C1 refactor,
// behavior-preserving). Already `export`ed in App.jsx; App.jsx renders it internally
// (and re-exports it from the barrel for the 7 page modules that import it from
// './App.jsx': CustomerPayments, DailyCap, FtdsInfo, CRGDeals, Deals, Dashboard,
// Partners). Pure render — contains JSX, hence `import React`.
import React from 'react';

// `className` (2026-08-04): stable `blitz-field` hook + an optional extra class, so a
// stylesheet can reach the wrapper (spacing, full-width span) without every caller
// growing a wrapper div. Purely additive — callers that pass nothing render as before.
export function Field({ label, children, className }) {
  return <div className={className ? `blitz-field ${className}` : "blitz-field"} style={{ marginBottom: 18 }}><label style={{ display: "block", color: "#64748B", fontSize: 11, fontWeight: 600, marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.8 }}>{label}</label>{children}</div>;
}
